// extracted by mini-css-extract-plugin
export var button = "slider-v2-module--button--3abca";
export var buttonsContainer = "slider-v2-module--buttonsContainer--0d641";
export var buttonsInfosContainer = "slider-v2-module--buttonsInfosContainer--a4a34";
export var icon = "slider-v2-module--icon--6c56c";
export var imageInfo = "slider-v2-module--imageInfo--96f3f";
export var imageTitle = "slider-v2-module--imageTitle--16487";
export var mainImage = "slider-v2-module--mainImage--bc59e";
export var mainImageContainer = "slider-v2-module--mainImageContainer--eaf63";
export var nextImage = "slider-v2-module--nextImage--626d3";
export var nextImageContainer = "slider-v2-module--nextImageContainer--288f3";
export var sliderContainer = "slider-v2-module--sliderContainer--1eb65";